/**
 * Componente para la  creacion del Do de Importacion
 * @author Henid Herrera <henid.herrera@repremundo.com.co>
 * @since 2025-09-17
 */
import {
  Box,
  Button,
  Flexbox,
  Heading,
  ModalFocus,
  ModalFocusContainer,
  shootToast,
  StepperSimple,
  Stack,
  StackRow,
  Radio,
  Label,
  Divider,
} from "codekit";
import { FormProvider, useForm, Controller } from "react-hook-form";
import {
  useCreateDoImpoMutation,
  useLazyGetManifiestoByDoQuery,
  useLazyGetGroupByImpoPerfilQuery,
  useGetDataTrackingQuery,
  useValidateInvoiceRestrictionsQuery,
} from "../../../../libs/redux/slices/Modimpxx/Creadoxx/CreadoxxApiSlice";
import { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiSlice } from "../../../../libs/redux/slices/apiSlice";
import { resetConsult } from "../../../../libs/redux/slices/consultSlice/consultSlice";
import { setRestoreFilts, getRestoreFilts } from "../../../../libs/redux/slices/trackingSlice/trackingSlice";

import Creadop1 from "./Creadop1";
import Creadop2 from "./Creadop2";
import Manifixx from "./Manifixx";

const Creadoxx = ({
  handleClose,
  row,
  setShowCreateDo = true,
  modurlxx,
  useAsModal = false,
  stepToShow = 1,
  onSelect,
}) => {
  const dispatch = useDispatch();
  const retore = useSelector(getRestoreFilts);
  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      APLIDOCT: modurlxx === "Doctraxx" ? "SI" : "SI"
    },
  });
  const {
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = methods;

  console.log(row);

  const [currentPageFacturas, setCurrentPageFacturas] = useState(1);
  const [perPageFacturas, setPerPageFacturas] = useState(10);
  const [currentPageTransportes, setCurrentPageTransportes] = useState(1);
  const [perPageTransportes, setPerPageTransportes] = useState(10);
  const [filterJson, setFilterJson] = useState({});
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [selectedTransportDocs, setSelectedTransportDocs] = useState([]);
  const [stepper, setStepper] = useState(stepToShow || 1);

  const [idempotencyKey] = useState(() => crypto.randomUUID());

  const [createDo, { isLoading }] = useCreateDoImpoMutation();
  const [getGroupByPerfil] = useLazyGetGroupByImpoPerfilQuery();
  const [fetchManifiestos] = useLazyGetManifiestoByDoQuery();
  const { data: validationData, isFetching: isValidating } = useValidateInvoiceRestrictionsQuery(
    {
      DSVCYYYY: selectedDocs,
      DTRCYYYY: selectedTransportDocs
    },
    { skip: selectedDocs.length === 0 }
  );

  const [isAplidoctEnabled, setIsAplidoctEnabled] = useState(false);
  const [docTipDe, setDocTipDe] = useState("INICIAL");


  const [selectedManifiesto, setSelectedManifiesto] = useState(null);
  const [showModalManifiesto, setShowModalManifiesto] = useState(false);
  const [manifiestosList, setManifiestosList] = useState([]);
  const [manifiestoSkipped, setManifiestoSkipped] = useState(false);

  const initialrowRef = useRef(null);
  const isSubmittingRef = useRef(false);
  const hasInitializedFacturasRef = useRef(false);
  const hasInitializedTransportesRef = useRef(false);

  const transportFilters = useMemo(() => {
    const baseFilters = [
      { "DTRCYYYY.REGESTXX": { "IN": ["ACTIVO"] } },
      { "DTRCYYYY.DOCTRAES": { "IN": ["CON SALDO", "COMPLETO"] } }
    ];

    let clienteId = null;

    if (selectedDocs && selectedDocs.length > 0) {
      clienteId = selectedDocs[0]?.CLIIDXXX;
    } else if (row && row.length > 0) {
      clienteId = row[0]?.CLIIDXXX;
    }

    if (clienteId) {
      baseFilters.push({ "DTRCYYYY.DTRCNICO": clienteId });
    }

    return baseFilters;
  }, [row, selectedDocs]);
  const invoiceFilters = useMemo(() => {
    const filters = [
      { "DSVCYYYY.REGESTXX": { "IN": ["ACTIVO"] } },
      { "DSVCYYYY.SAFAESTX": { "IN": ["CON SALDO", "COMPLETO"] } }
    ];

    if (row && row.length > 0) {
      const r = row[0];

      const clienteId =
        r.CLIIDXXX ??
        r.DTRCNICO ??
        null;

      if (clienteId) {
        filters.push({ "DSVCYYYY.CLIIDXXX": clienteId });
      }
    }

    return filters;
  }, [row]);


  const isSelectiveInvoice = useMemo(() => {
    return row?.some((item) => item.FACIDXXX) || false;
  }, [row]);

  const isSelectiveTransport = useMemo(() => {
    return row?.some((item) => item.DTRCDOTR) || false;
  }, [row]);

  const dynamicInvoiceFilters = useMemo(() => {
    if (!isSelectiveInvoice) return [];
    const invoiceValues = selectedDocs.map((doc) => doc.FACIDXXX).filter(Boolean);
    return invoiceValues.length > 0
      ? [{ "DSVCYYYY.FACIDXXX": { IN: invoiceValues } }]
      : [];
  }, [selectedDocs, isSelectiveInvoice]);

  const dynamicTransportFilters = useMemo(() => {
    if (!isSelectiveTransport) return [];
    const transportValues = selectedTransportDocs
      .map((doc) => doc.DTRCDOTR)
      .filter(Boolean);
    return transportValues.length > 0
      ? [{ "DTRCYYYY.DTRCDOTR": { IN: transportValues } }]
      : [];
  }, [selectedTransportDocs, isSelectiveTransport]);

  // Validación en tiempo real al seleccionar facturas
  useEffect(() => {
    if (validationData?.data) {
      // Si el back permite elegir (ej: Anticipada Voluntaria), habilitamos la pregunta
      setIsAplidoctEnabled(validationData.data.canApplyDoct);
      setDocTipDe(validationData.data.docTipDe);

      // Por defecto (99% de los casos) es obligatorio el DT.
      if (!validationData.data.canApplyDoct) {
        setValue("APLIDOCT", "SI");
      }
    } else if (selectedDocs.length === 0) {
      setIsAplidoctEnabled(false);
      setDocTipDe("INICIAL");
      setValue("APLIDOCT", "SI");
    }
  }, [validationData, selectedDocs, setValue]);

  useEffect(() => {
    if (useAsModal && stepToShow) {
      setFilterJson({});
      setStepper(stepToShow);
    }
  }, [useAsModal, stepToShow]);

  const {
    data: dataFacturas,
    isLoading: isLoadingFacturas,
    isFetching: isFetchingFacturas,
  } = useGetDataTrackingQuery(
    {
      page: currentPageFacturas,
      per_page: perPageFacturas,
      sorts: "-REGFECXX,-REGHORXX",
      MODURLXX: "Faccomxx",
      PRODURLX: "Salfactx",
      filtersJson: JSON.stringify([
        ...invoiceFilters,
        ...(Object.keys(filterJson).length === 0 ? dynamicInvoiceFilters : [filterJson]),
      ]),
    },
    { skip: stepper !== 1 }
  );

  const {
    data: dataTransporte,
    isLoading: isLoadingTransporte,
  } = useGetDataTrackingQuery(
    {
      page: currentPageTransportes,
      per_page: perPageTransportes,
      sorts: "-REGFECXX,-REGHORXX",
      MODURLXX: "Doctraxx",
      PRODURLX: "Saldoctr",
      filtersJson: JSON.stringify([
        ...transportFilters,
        ...(Object.keys(filterJson).length === 0 ? dynamicTransportFilters : [filterJson]),
      ]),
    },
    { skip: stepper !== 2 }
  );


  useEffect(() => {
    if (!hasInitializedFacturasRef.current && row?.length > 0) {
      const initialSelected = row.filter(r => r.FACIDXXX);
      if (initialSelected.length > 0) {
        setSelectedDocs(initialSelected);
        hasInitializedFacturasRef.current = true;
      }
    }
  }, [row]);

  useEffect(() => {
    if (!hasInitializedTransportesRef.current && row?.length > 0) {
      const initialSelected = row.filter(r => r.DTRCDOTR);
      if (initialSelected.length > 0) {
        setSelectedTransportDocs(initialSelected);
        hasInitializedTransportesRef.current = true;
      }
    }
  }, [row]);

  useEffect(() => {
    if (stepper === 2 && selectedTransportDocs.length > 0 && !useAsModal) {
      const rawFilter = {
        DTRCDOTR: selectedTransportDocs[0]?.DTRCDOTR,
        CLIIDXXX: selectedDocs[0]?.CLIIDXXX,
      };
      const payload = Object.entries(rawFilter).reduce((acc, [key, val]) => {
        acc[`filter[${key}]`] = val;
        return acc;
      }, {});

      fetchManifiestos(payload)
        .then(res => {
          const list = res?.data?.data || [];
          if (list.length > 1) {
            setManifiestoSkipped(false);
            setManifiestosList(list);
            setShowModalManifiesto(true);
          } else {
            setSelectedManifiesto(list[0] || null);
            setManifiestosList(list);
            setShowModalManifiesto(false);
          }
        })
        .catch(err => {
          console.error("Error al obtener manifiestos", err);
          setManifiestosList([]);
          setSelectedManifiesto(null);
        });
    } else if (stepper !== 2) {
      setSelectedManifiesto(null);
      setManifiestosList([]);
      setShowModalManifiesto(false);
    }
  }, [stepper, selectedTransportDocs, selectedDocs, useAsModal]);

  const handleSaveManifiesto = (manifiesto) => {
    setSelectedManifiesto(manifiesto);
    setManifiestoSkipped(false);
    setShowModalManifiesto(false);
  };

  const handleSkipManifiesto = () => {
    setManifiestoSkipped(true);
    setSelectedManifiesto(null);
  };

  const handleSetStep = (step) => {
    if (useAsModal) return;
    setFilterJson({});
    setStepper(step);
  };

  const onSubmit = async (data) => {
    if (useAsModal) return;
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;

    const copyData = { ...data, idempotencyKey };
    let docsDTRC = [...selectedTransportDocs];
    let docsDSVC = [...selectedDocs];
    if (docsDTRC && docsDTRC.length > 0) {
      const maxItem = docsDTRC.reduce((prev, current) =>
        Number(current.IDARCHXX || 0) < Number(prev.IDARCHXX || 0)
          ? current
          : prev
      );
      copyData.DOCTRIMP = maxItem.DTRCDOTR || "";
      copyData.DEPIDXXX = maxItem.DEPIDXXX || "";
      copyData.TRANIDXX = maxItem.DTRCEMTR || "";
      copyData.FECEMIDT = maxItem.DTRCFCDT || "";
      copyData.DOCNUMAX = selectedManifiesto ? selectedManifiesto.DTTINUMA : (maxItem.DTTINUMA || "");
      copyData.DOCFEMAX = maxItem.DTTIFEMA || "";
      copyData.DOCRDTAX = maxItem.DTRCTPOP === "DTA" ? "SIACO" : (maxItem.DTRCTPOP === "OTM" ? "CLIENTE" : "");
      copyData.DOCJURAD = maxItem.DTRCLUIN || "";
      copyData.DOCJURAO = maxItem.ODIIDDES || "";
      copyData.MTRIDXXX = maxItem.DTRCMETR || "";
      copyData.DOCMTXXX = maxItem.DTRCMETR || "";
      copyData.DOCDDOEU = maxItem.DTRCAPEU || "";
      copyData.PAIIDPRX = maxItem.DRTCPAPR || "";
      copyData.DTRCYYYY = docsDTRC.map((doc) => ({
        DTRCDOTR: doc.DTRCDOTR,
        DTRCNICO: doc.DTRCNICO,
        IDARCHXX: doc.IDARCHXX,
      }));
    } else {
      copyData.DTRCYYYY = [];
      copyData.DOCTRIMP = "";
      copyData.DEPIDXXX = "";
      copyData.TRANIDXX = "";
      copyData.FECEMIDT = "";
      copyData.DOCNUMAX = "";
      copyData.DOCFEMAX = "";
      copyData.DOCRDTAX = "";
      copyData.DOCJURAO = "";
      copyData.DOCJURAD = "";
    }
    if (docsDSVC && docsDSVC.length > 0) {
      const maxItem = docsDSVC.reduce((prev, current) =>
        Number(current.VALFOBXX || 0) > Number(prev.VALFOBXX || 0)
          ? current
          : prev
      );
      copyData.DOIPEDXX = maxItem.DOIPEDXX || "";
      copyData.DOCTIPDE = docTipDe;
      copyData.IDPROXXX = maxItem.IDPROXXX || "";
      copyData.DSVCYYYY = docsDSVC.map((doc) => ({
        CLIIDXXX: doc.CLIIDXXX,
        IDPROXXX: doc.IDPROXXX,
        FACIDXXX: doc.FACIDXXX,
      }));
    } else {
      copyData.DSVCYYYY = [];
      copyData.DOIPEDXX = "";
      copyData.IDPROXXX = "";
    }

    console.log("Payload Final a enviar al Back-end:", copyData);
    try {
      await createDo(copyData)
        .unwrap()
        .then((response) => {
          shootToast({
            variant: "success",
            text: `Se ha creado el DO correctamente con ID ${response.DOCNROXX}.`,
            duration: 5000,
            autoHide: true,
          });
          // Forzar la invalidación manual de tags para asegurar que las tablas de tracking se refresquen
          dispatch(apiSlice.util.invalidateTags(["Create", "Consult"]));
          dispatch(resetConsult());
          dispatch(setRestoreFilts(!retore));
          handleClose();
          setShowCreateDo(false);
        })
        .catch((error) => {
          console.error("Error al crear DO", error);
          shootToast({
            variant: "error",
            text: `Error al crear DO: ${error.data?.mensaje ?? "Ocurrió un error desconocido."
              }`,
            duration: 5000,
            autoHide: true,
          });
        });
    } catch (error) {
      console.error("Error general en el proceso de creación de DO:", error);
    } finally {
      isSubmittingRef.current = false;
    }
  };

  const handlePageChange = (newPage) => {
    if (stepper === 1) {
      setCurrentPageFacturas(newPage);
    } else {
      setCurrentPageTransportes(newPage);
    }
  };

  const handlePerPageChange = (newPerPage) => {
    if (stepper === 1) {
      setPerPageFacturas(newPerPage);
      setCurrentPageFacturas(1);
    } else {
      setPerPageTransportes(newPerPage);
      setCurrentPageTransportes(1);
    }
  };

  const handleFilterChange = (column, value) => {
    const finalValue =
      typeof value === "object" && value !== null && "value" in value
        ? value.value
        : value;

    if (!finalValue || (typeof finalValue === "string" && finalValue.trim() === "")) {
      setFilterJson({});
      return;
    }

    const prefix = stepper === 1 ? "DSVCYYYY" : "DTRCYYYY";

    const dynamicFilter = {
      [`${prefix}.${column}`]: {
        LIKE: [finalValue],
      },
    };
    setFilterJson(dynamicFilter);
    if (stepper === 1) {
      setCurrentPageFacturas(1);
    } else {
      setCurrentPageTransportes(1);
    }
  };

  const handleCheckedRows = (checkedRows) => {
    const rows = checkedRows?.rows ?? [];
    const visibleRows = dataFacturas?.data ?? [];
    const visibleIds = new Set(visibleRows.map(r => r.FACIDXXX));

    setSelectedDocs(prevSelected => {
      // Filtrar los que estaban seleccionados pero que ya no lo están en la vista actual
      const filteredPrev = prevSelected.filter(r => !visibleIds.has(r.FACIDXXX));
      // Combinar con los nuevos seleccionados de la vista actual
      const newSelected = [...filteredPrev, ...rows];

      if (useAsModal && typeof onSelect === "function" && stepper === 1) {
        onSelect(newSelected);
      }
      return newSelected;
    });
  };

  const handleCheckedTransportRows = (checkedRows) => {
    const rows = checkedRows?.rows ?? [];
    const visibleRows = dataTransporte?.data ?? [];
    const visibleIds = new Set(visibleRows.map(r => r.DTRCDOTR));

    setSelectedTransportDocs(prevSelected => {
      // Filtrar los que estaban seleccionados pero que ya no lo están en la vista actual
      const filteredPrev = prevSelected.filter(r => !visibleIds.has(r.DTRCDOTR));
      // Combinar con los nuevos seleccionados de la vista actual
      const newSelected = [...filteredPrev, ...rows];

      if (useAsModal && typeof onSelect === "function" && stepper === 2) {
        onSelect(newSelected);
      }
      return newSelected;
    });
  };

  const validateSameClient = (invoices, transportDocs) => {
    if (useAsModal) return { valid: true };

    if (invoices.length === 0) return { valid: true };
    const firstClientInInvoice = invoices[0]?.CLIIDXXX;
    const allInvoicesSameClient = invoices.every(
      (doc) => doc?.CLIIDXXX === firstClientInInvoice
    );

    if (!allInvoicesSameClient) {
      return {
        valid: false,
        message:
          "Estás seleccionando documentos de diferentes clientes, por favor valide.",
      };
    }
    if (transportDocs.length > 0) {
      const allTransportSameClientAsInvoice = transportDocs.every(
        (doc) => doc?.DTRCNICO === firstClientInInvoice
      );

      if (!allTransportSameClientAsInvoice) {
        return {
          valid: false,
          message:
            "Debe seleccionar facturas y documentos de transporte del mismo cliente, por favor valide.",
        };
      }

      if (transportDocs.length > 1) {
        const areAllZonaFranca = transportDocs.every(
          (row) =>
            row.DEPDESXX &&
            row.DEPDESXX.toLowerCase().includes("zona franca")
        );

        if (!areAllZonaFranca) {
          return {
            valid: false,
            message:
              "Solo puede seleccionar un Documento de Transporte si el depósito no es Zona Franca.",
          };
        }
        const firstDepId = transportDocs[0].DEPIDXXX;
        const allSameDepId = transportDocs.every(
          (row) => row.DEPIDXXX === firstDepId
        );
        if (!allSameDepId) {
          return {
            valid: false,
            message:
              "Los Documentos de transporte no cuentan con el mismo Depósito por favor valide.",
          };
        }
      }
    }
    return { valid: true };
  };

  const isZonaFranca = useMemo(() => {
    if (selectedTransportDocs.length === 0) return false;

    return selectedTransportDocs.every(
      (row) =>
        row.DEPDESXX &&
        row.DEPDESXX.toLowerCase().includes("zona franca")
    );
  }, [selectedTransportDocs]);


  const handleNextStep = async () => {
    if (useAsModal) return;

    const clientValidation = validateSameClient(selectedDocs, []);

    if (!clientValidation.valid) {
      shootToast({
        variant: "warning",
        text: clientValidation.message,
        duration: 5000,
      });
      return;
    }

    const APLIDOCT = watch("APLIDOCT");
    const clientId = selectedDocs[0]?.CLIIDXXX;
    let groupsData = [];
    if (clientId) {
      try {
        const response = await getGroupByPerfil({ CLIIDXXX: clientId }).unwrap();
        groupsData = response?.data ?? [];
      } catch (error) {
        console.error("Error al obtener grupos de perfil", error);
      }
    }
    const doipedxx = selectedDocs
      .filter((doc) => doc.DOIPEDXX && doc.DOIPEDXX.trim() !== "")
      .map((doc) => doc.DOIPEDXX)
      .join(",");

    const payload = {
      APLIDOCT: "NO",
      DSVCYYYY: selectedDocs,
      CLIIDXXX: clientId,
      USRJEFOG: groupsData[0]?.value ?? "",
      MTRIDXXX: "01",
      DOCJURAD: "03",
      DOCJURAO: "03",
      CCOIDXXX: groupsData[0]?.CCOIDXXX ?? "",
      SUBCCOID: groupsData[0]?.SUBCCOID ?? "",
      USRGRUXX: groupsData[0]?.GRUPLIDX ?? "",
      DOCTIPXX: "IMPORTACION",
      DOIPEDXX: doipedxx,
      DOCRDTAX: "",
      TRANIDXX: "",
      FECEMIDT: "",
      DOCNUMAX: "",
      DOCFEMAX: "",
    };

    if (APLIDOCT === "NO") {
      onSubmit(payload);
    } else {
      setFilterJson({});
      setStepper(2);
    }
  };

  const handleFinalSubmit = handleSubmit(async (formData) => {
    if (useAsModal) return;

    const clientValidation = validateSameClient(selectedDocs, selectedTransportDocs);

    if (!clientValidation.valid) {
      shootToast({
        variant: 'warning',
        text: clientValidation.message,
        duration: 5000,
      });
      return;
    }
    const clientId = selectedDocs[0]?.CLIIDXXX;
    let groupsData = [];
    if (clientId) {
      try {
        const response = await getGroupByPerfil({ CLIIDXXX: clientId }).unwrap();
        groupsData = response?.data ?? [];
      } catch (error) {
        console.error("Error al obtener grupos de perfil", error);
      }
    }
    const doctrimp = selectedTransportDocs.length > 0
      ? selectedTransportDocs.map(doc => doc.DTRCDOTR).join('-')
      : "";
    const doipedxx = selectedDocs
      .filter(doc => doc.DOIPEDXX && doc.DOIPEDXX.trim() !== '')
      .map(doc => doc.DOIPEDXX)
      .join(',');
    const finalPayload = {
      ...formData,
      idempotencyKey,
      DSVCYYYY: selectedDocs,
      DTRCYYYY: selectedTransportDocs,
      CLIIDXXX: clientId,
      USRJEFOG: groupsData[0]?.value ?? "",
      MTRIDXXX: "01",
      DOCJURAD: "03",
      DOCJURAO: "03",
      CCOIDXXX: groupsData[0]?.CCOIDXXX ?? "",
      SUBCCOID: groupsData[0]?.SUBCCOID ?? "",
      USRGRUXX: groupsData[0]?.GRUPLIDX ?? "",
      DOCTIPXX: "IMPORTACION",
      DOCTRIMP: doctrimp,
      DOIPEDXX: doipedxx,
      DOCRDTAX: "",
      TRANIDXX: "",
      FECEMIDT: "",
      DOCNUMAX: "",
      DOCFEMAX: "",
    };
    onSubmit(finalPayload);
  });

  const APLIUNIF = watch("APLIUNIF");
  const isFinalButtonDisabled =
    selectedTransportDocs.length === 0 ||
    (!APLIUNIF && isZonaFranca) ||
    (manifiestosList.length > 1 && !selectedManifiesto && !manifiestoSkipped);
  const isContinueButtonDisabled =
    selectedDocs.length === 0 ||
    (isAplidoctEnabled && selectedDocs.length > 0 && !watch("APLIDOCT"));

  if (useAsModal) {
    return (
      <FormProvider {...methods}>
        <Box spacingX={4} spacingY={8} borderTop={0}>
          {stepper === 1 && (
            <ModalFocusContainer>
              <Box mb={2}>
                <Box mt={7} mb={7}>
                  <Divider
                    text="Asociar Documento Soporte Valor"
                    color="accent-600"
                  />
                  <Box mt={7}>
                    {dataFacturas && (
                      <Creadop1
                        data={dataFacturas?.data}
                        meta={dataFacturas?.meta}
                        onPageChange={handlePageChange}
                        onPerPageChange={handlePerPageChange}
                        onFilterChange={handleFilterChange}
                        isLoading={isLoadingFacturas || isFetchingFacturas}
                        handleCheckedRows={handleCheckedRows}
                        checkedRows={selectedDocs}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </ModalFocusContainer>
          )}

          {stepper === 2 && (
            <ModalFocusContainer>
              <Box mb={2}>
                <Box mt={7} mb={7}>
                  <Divider
                    text="Asociar Documento de Transporte"
                    color="accent-600"
                  />
                  <Box mt={7}>
                    {dataTransporte && (
                      <Creadop2
                        data={dataTransporte?.data}
                        meta={dataTransporte?.meta}
                        onPageChange={handlePageChange}
                        onPerPageChange={handlePerPageChange}
                        onFilterChange={handleFilterChange}
                        isLoading={isLoadingTransporte}
                        handleCheckedRows={handleCheckedTransportRows}
                        checkedRows={selectedTransportDocs}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </ModalFocusContainer>
          )}
        </Box>
      </FormProvider>
    );
  }

  return (
    <ModalFocus isOpen>
      <Manifixx
        showModal={showModalManifiesto}
        setShowModal={setShowModalManifiesto}
        manifiestos={manifiestosList}
        onSave={handleSaveManifiesto}
        onSkip={handleSkipManifiesto}
      />
      <Box spacing={4} borderBottom={1} borderColor="neutral-300">
        <ModalFocusContainer>
          <Flexbox justifyContent="between">
            <Flexbox justifyContent="start" alignItems="center" gap={4}>
              <Heading variant="heading-6">Nuevo DO de Importacion</Heading>
            </Flexbox>
            <Flexbox justifyContent="end" alignItems="center" gap={4}>
              <Button
                variant="secondary"
                size="2l"
                icon="close"
                onClick={() => {
                  handleClose();
                }}
                minWidth={163}
                onlyIconMobile
                hideIconDesktop
              >
                Cancelar
              </Button>
            </Flexbox>
          </Flexbox>
        </ModalFocusContainer>
      </Box>
      <FormProvider {...methods}>
        <form onSubmit={handleFinalSubmit}>
          <Box spacingX={4} spacingY={8} borderTop={1}>
            <Stack>
              <StepperSimple steps={2} value={stepper} onClick={(step) => handleSetStep(step)} />
            </Stack>
          </Box>
          {stepper === 1 && (
            <ModalFocusContainer>
              <Box mb={2}>
                <Box mt={7} mb={7}>
                  <Divider text="Asociar Documento Soporte Valor" color="accent-600" />
                  <Box mt={7}>
                    {dataFacturas && (
                      <Creadop1
                        data={dataFacturas?.data}
                        meta={dataFacturas?.meta}
                        onPageChange={handlePageChange}
                        onPerPageChange={handlePerPageChange}
                        onFilterChange={handleFilterChange}
                        isLoading={isLoadingFacturas || isFetchingFacturas}
                        handleCheckedRows={handleCheckedRows}
                        checkedRows={selectedDocs}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
              {isAplidoctEnabled && (
                <Box>
                  <Stack columnsVariant="form-2">
                    <StackRow>
                      <Label>¿Cuenta con Documento de Transporte?</Label>
                      <Box
                        border={1}
                        spacing={2}
                        rounded="md"
                        borderColor={
                          errors?.APLIDOCT ? "primary-600" : "neutral-300"
                        }
                      >
                        <Flexbox gap={7}>
                          <Flexbox>
                            <Controller
                              control={methods.control}
                              name={`APLIDOCT`}
                              rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <Radio
                                  value={value}
                                  checked={value === "SI"}
                                  onChange={() => {
                                    onChange("SI");
                                  }}
                                >
                                  SI
                                </Radio>
                              )}
                            />
                          </Flexbox>
                          <Flexbox>
                            <Controller
                              control={methods.control}
                              name={`APLIDOCT`}
                              rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <Radio
                                  value={value}
                                  checked={value === "NO"}
                                  onChange={() => {
                                    onChange("NO");
                                  }}
                                >
                                  NO
                                </Radio>
                              )}
                            />
                          </Flexbox>
                        </Flexbox>
                      </Box>
                    </StackRow>
                  </Stack>
                </Box>
              )}
            </ModalFocusContainer>
          )}

          {stepper === 2 && (
            <ModalFocusContainer>
              <Box>
                {selectedTransportDocs.length > 0 && isZonaFranca && (
                  <Stack columnsVariant="form-2">
                    <StackRow>
                      <Label>¿Se trata de una operación con unificación de documento de transporte?</Label>
                      <Box
                        border={1}
                        spacing={2}
                        rounded="md"
                        borderColor={
                          errors?.APLIUNIF ? "primary-600" : "neutral-300"
                        }
                      >
                        <Flexbox gap={7}>
                          <Flexbox>
                            <Controller
                              control={methods.control}
                              name={`APLIUNIF`}
                              rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <Radio
                                  value={value}
                                  checked={value === "SI"}
                                  onChange={() => {
                                    onChange("SI");
                                  }}
                                >
                                  SI
                                </Radio>
                              )}
                            />
                          </Flexbox>
                          <Flexbox>
                            <Controller
                              control={methods.control}
                              name={`APLIUNIF`}
                              rules={{ required: true }}
                              render={({ field: { onChange, value } }) => (
                                <Radio
                                  value={value}
                                  checked={value === "NO"}
                                  onChange={() => {
                                    onChange("NO");
                                  }}
                                >
                                  NO
                                </Radio>
                              )}
                            />
                          </Flexbox>
                        </Flexbox>
                      </Box>
                    </StackRow>
                  </Stack>
                )}
              </Box>
              <Box mb={2}>
                <Box mt={7} mb={7}>
                  <Divider text="Asociar Documento de Transporte" color="accent-600" />
                  <Box mt={7} >
                    {dataTransporte && (
                      <Creadop2
                        data={dataTransporte?.data}
                        meta={dataTransporte?.meta}
                        onPageChange={handlePageChange}
                        onPerPageChange={handlePerPageChange}
                        onFilterChange={handleFilterChange}
                        isLoading={isLoadingTransporte}
                        handleCheckedRows={handleCheckedTransportRows}
                        checkedRows={selectedTransportDocs}
                      />
                    )}
                  </Box>
                </Box>
              </Box>
            </ModalFocusContainer>
          )}

          <Box spacingX={4} spacingY={8} borderTop={1} borderColor="neutral-300">
            <ModalFocusContainer>
              <Flexbox justifyContent="between" alignItems="center" gap={4}>
                <Button
                  type="button"
                  variant="secondary"
                  size="2l"
                  minWidth={200}
                  onClick={stepper === 1 ? () => handleClose() : () => handleSetStep(1)}
                >
                  {stepper === 1 ? "Cancelar" : "Anterior"}
                </Button>
                <Flexbox gap={4}>
                  {stepper === 1 && (
                    <Button
                      type="button"
                      variant="primary-bold"
                      size="2l"
                      minWidth={200}
                      onClick={handleNextStep}
                      disabled={isContinueButtonDisabled}
                    >
                      Continuar
                    </Button>
                  )}
                  {stepper === 2 && (
                    <Button
                      type="submit"
                      variant="primary-bold"
                      size="2l"
                      isLoading={isLoading}
                      disabled={isFinalButtonDisabled || isLoading}
                      minWidth={200}
                    >
                      Finalizar
                    </Button>
                  )}
                </Flexbox>
              </Flexbox>
            </ModalFocusContainer>
          </Box>
        </form>
      </FormProvider>
    </ModalFocus>
  );
};

export default Creadoxx;
